import { FC } from 'react';
import { styled, Typography } from '@mui/material';
import { AlertIcon } from 'assets';
import { palette } from 'view/themes/palette';

interface IInputErrorWithIconProps {
  errorText: string;
}

const InputError = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  color: palette.alerts.error,
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
}) as typeof Typography;

const InputErrorWithIcon: FC<IInputErrorWithIconProps> = ({ errorText }) => {
  return (
    <InputError component="span">
      <AlertIcon /> {errorText}
    </InputError>
  );
};

export default InputErrorWithIcon;
